// AI Generated Test
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { DataPrivacyViolationRepoService } from '@client/app/modules/data-privacy/services/api/data-privacy-violation-repo/data-privacy-violation-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { DataPrivacyService } from '@client/app/modules/data-privacy/services/data-privacy/data-privacy.service';
import { HelpCenterRepoService } from '@client/app/modules/data-privacy/services/api/help-center-repo/help-center-repo.service';
import { DataPrivacyRulesetRepo } from '@client/app/modules/data-privacy/services/api/ruleset_repo';
import { DirectNavigationService } from '@monsido/services/direct-navigation-service/direct-navigation.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';


import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'page-details-section-data-privacy',
    standalone: false,
    template: `
        <div id="page-details-data-policy" class="max-height data-privacy">
            <div class="row page-details-section-header max-height">
                <div class="col-16 col-md-12 col-lg-10 pr-0 page-details-sitemenu border-right max-height scroll">
                    <ul class="sidebar-nav">
                        <li *ngIf="showDataProtectionIssues">
                            <a [class.active]="active === 'data-issues'"
                               [attr.aria-label]="'Data Issues' | translate"
                               (click)="active = 'data-issues'"
                               monEventTrigger
                               [monEventTrigger]="'actionTrigger'"
                               [monEventParams]="{action: 'page-details-data-privacy-data-issues'}">
                                <span class="fa-fw mr-2" [ngClass]="(['SIDEMENUES', 'DATA_PRIVACY', 'ISSUES'] | monIcons)" aria-hidden="true"></span>
                                <span translate>Data Issues</span>
                            </a>
                        </li>
                        <li *ngIf="isDemo">
                            <a [class.active]="active === 'cookie-acceptance-rate'"
                               [attr.aria-label]="'Cookie Acceptance Rate' | translate"
                               (click)="active = 'cookie-acceptance-rate'"
                               monEventTrigger
                               [monEventTrigger]="'actionTrigger'"
                               [monEventParams]="{action: 'page-details-data-privacy-cookie-acceptance-rate'}">
                                <span class="fa-fw mr-2"
                                      [ngClass]="(['SIDEMENUES', 'DATA_PRIVACY', 'CONSENT_OVERVIEW', 'COOKIE_BITE'] | monIcons)"
                                      aria-hidden="true"></span>
                                <span translate>Cookie Acceptance Rate</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-32 col-md-36 col-lg-38 max-height scroll bg-light-grey">
                    <div class="row max-height" *ngIf="active === 'data-issues'">
                        <div class="col-48">
                            <page-header [icon]="['MENUES', 'DATA_PRIVACY'] | monIcons" [header]="'Data Privacy' | translate">
                                <page-header-content>
                                    <div class="row">
                                        <div class="col-48 text-right">
                                            <table-compliance
                                                class="inline-block outer-small-minus"
                                                [data]="complianceData"
                                                [labels]="['', '']"
                                                size="46"
                                                [btnWord]="'Overall Data Privacy compliance for this page' | translate"
                                                [indexNumber]="0">
                                            </table-compliance>
                                        </div>
                                    </div>
                                </page-header-content>
                            </page-header>
                        </div>
                        <div class="d-flex col-48 max-height scroll bg-light-grey">
                            <div class="table-wrapper mt-4">
                                <div class="bg-white mt-1 panel-monsido-card">
                                    <div class="p-0">
                                        <mon-tabs
                                            [options]="tabs"
                                            [(status)]="activeTab"
                                            [maxOptionsDisplay]="6"
                                            (onStatus)="onStatus($event)">
                                        </mon-tabs>
                                        <hr class="m-0">
                                        <table-container [noResultMessage]="'Good job! No violations were found' | translate"
                                                         [collection]="infoTypes"
                                                         (onPageChange)="onPageChange($event)"
                                                         (onPerPageChange)="onPageSizeChange($event)"
                                                         [progress]="progress"
                                                         class="pages-table-wrapper">
                                            <table class="table">
                                                <thead>
                                                <tr>
                                                    <th monTableSort
                                                        [monSortBy]="'identifier'"
                                                        [monSortDirection]="currentSort.direction"
                                                        [monCurrentlySortedBy]="currentSort.by"
                                                        (monOnSorted)="onMonTableSort($event)"
                                                        class="pl-3">
                                                        {{ 'Issue' | translate }}
                                                    </th>
                                                    <th monTableSort
                                                        [monSortBy]="'priority'"
                                                        [monSortDirection]="currentSort.direction"
                                                        [monCurrentlySortedBy]="currentSort.by"
                                                        (monOnSorted)="onMonTableSort($event)"
                                                        class="text-right pr-3">
                                                        {{ 'Severity' | translate }}
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let infoType of infoTypes"
                                                    (click)="setSelectedInfoType(infoType)"
                                                    [ngClass]="{'active': selectedInfoType && selectedInfoType.id === infoType.id}">
                                                    <td class="text-v-middle pl-3">
                                                        <div class="d-flex align-items-center">
                                                            <mon-data-privacy-info-type-icon [monGroup]="infoType.group"
                                                                                    [monPriority]="infoType.priority"
                                                                                    [monTooltipText]="formatText(infoType.group || 'other') | translate">
                                                            </mon-data-privacy-info-type-icon>
                                                            <p class="my-0 pl-2">{{infoType.name}}</p>
                                                        </div>
                                                    </td>
                                                    <td class="text-right text-v-middle pr-3">
                                                        <mon-data-privacy-severity-level [monPriority]="infoType.priority"
                                                                                         *ngIf="!loading">
                                                        </mon-data-privacy-severity-level>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </table-container>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-fill table-wrapper mt-4" *ngIf="selectedInfoType">
                                <div class="panel-monsido-card mt-1 page-details-section-body">
                                    <div class="card-header bg-light-grey">
                                        <div class="d-flex">
                                            <mon-data-privacy-info-type-icon [monGroup]="selectedInfoType.group"
                                                                    [monPriority]="selectedInfoType.priority">
                                            </mon-data-privacy-info-type-icon>
                                            <div class="side-panel-header ml-1 mb-1 align-middle">
                                                {{ selectedInfoType.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bg-white">
                                        <mon-tabs
                                            [options]="detailTabs"
                                            [(status)]="activeDetailTab">
                                        </mon-tabs>
                                        <hr class="mt-0 mb-0">
                                        <div id="privacy-page-details-info" class="pb-1" *ngIf="activeDetailTab === 'info'">
                                            <table class="violation-table table mb-4 w-100">
                                                <tr *ngFor="let violation of violations" tabindex="0" class="row">
                                                    <td class="text-v-middle col-48 col-xl-15">
                                                        <p class="ml-3 pt-2">{{ violation.content }}</p>
                                                    </td>
                                                    <td class="text-v-middle col-48 col-xl-33 text-right">
                                                        <div class="pull-right">
                                                            <mon-data-privacy-dropdown [monViolation]="violation"
                                                                                       [monActiveTab]="activeTab"
                                                                                       (monUpdateCallback)="update($event.status, $event.violation, $event.confirmMessage)">
                                                            </mon-data-privacy-dropdown>
                                                            <button class="btn btn-border-radius btn-secondary ml-2"
                                                                    [triggers]="'focus hover'"
                                                                    [ngbTooltip]="'Open issue page' | translate"
                                                                    (click)="openIssueModal(violation)">
                                                                <span class="fas fa-info-circle" aria-hidden="true"></span>
                                                            </button>
                                                            <mon-extension-visual-link-button class="ml-2 mr-3"
                                                                                              [page]="pageObj"
                                                                                              [type]="'dpriv'"
                                                                                              [data]="{violation: violation}">
                                                            </mon-extension-visual-link-button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="pb-1" *ngIf="activeDetailTab === 'help'">
                                            <div class="row">
                                                <div class="col-lg-48 px-6 py-2">
                                                    <mon-spinner [loading]="quickHelpLoading">
                                                        <div class="data-privacy-help-center-description-container">
                                                            <h4 class="mt-0" translate>Description</h4>
                                                            <div [innerHTML]="description"></div>
                                                        </div>
                                                    </mon-spinner>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row max-height" *ngIf="active === 'cookie-acceptance-rate'">
                        <div class="col-48 max-height bg-light-grey">
                            <page-details-cookie-acceptance-rate></page-details-cookie-acceptance-rate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSectionDataPrivacyComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() pageObj: any;
    @Input() active: any;
    @Output() refreshPage = new EventEmitter<any>();

    isDemo: boolean = false;
    showDataProtectionIssues: boolean = false;
    tabs: any[] = [];
    detailTabs: any[] = [];
    activeDetailTab: string = '';
    complianceData: any[] = [0, 100];
    description: string = '';
    quickHelpLoading: boolean = false;
    violations: any[] = [];
    infoTypes: any[] = [];
    selectedInfoType: any = null;
    reloadDataPrivacyEventId: any;
    progress: any;
    loading: boolean = false;

    constructor (
        private dataPrivacyViolationRepoService: DataPrivacyViolationRepoService,
        private translateService: TranslateService,
        private dataPrivacyService: DataPrivacyService,
        private helpCenterRepoService: HelpCenterRepoService,
        private dataPrivacyRulesetRepo: DataPrivacyRulesetRepo,
        private directNavigationService: DirectNavigationService,
        private monEventService: MonEventService,
        private monModalService: MonModalService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.isDemo = this.pipeService.get('monCustomerHasPlan')('demo');
        this.showDataProtectionIssues = this.sessionService.domain?.features?.data_protection || false;
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                value: 'all',
            },
            {
                name: this.translateService.getString('High'),
                value: 'high',
            },
            {
                name: this.translateService.getString('Medium'),
                value: 'medium',
            },
            {
                name: this.translateService.getString('Low'),
                value: 'low',
            },
            {
                name: this.translateService.getString('Ignored'),
                value: 'ignored',
            },
            {
                name: this.translateService.getString('Fixed'),
                value: 'fixed',
            },
        ];
        this.detailTabs = [
            {
                name: this.translateService.getString('Information'),
                value: 'info',
            },
            {
                name: this.translateService.getString('Quick help'),
                value: 'help',
            },
        ];
        this.currentSort.by = 'identifier';
        this.currentSort.direction = 'desc';
        this.activeDetailTab = this.detailTabs[0].value;
        if (this.active) {
            this.activeTab = this.active.priority;
        } else {
            this.activeTab = 'all';
        }
        this.active = this.selectDataPrivacySection();
        this.complianceData = [0, 100];
        this.description = '';
        this.quickHelpLoading = false;
        this.violations = [];
        this.infoTypes = [];
        this.selectedInfoType = null;

        this.reloadDataPrivacyEventId = this.monEventService.addListener('reloadDataPrivacy', () => {
            this.getPage();
        });

        this.getPage();
    }

    ngOnDestroy (): void {
        this.monEventService.remove(this.reloadDataPrivacyEventId);
    }

    selectDataPrivacySection (): string {
        const dataPrivacySections = ['data-issues', 'cookie-acceptance-rate'];
        const index = dataPrivacySections.indexOf(this.active);
        if (this.isDemo && !this.showDataProtectionIssues) {
            return 'cookie-acceptance-rate';
        }
        if (index === -1) {
            return 'data-issues';
        }
        return dataPrivacySections[index];
    }

    override getPage = (): void => {
        const getPageParams: any = {
            page: this.page,
            page_size: 0,
            sort_dir: this.currentSort.direction,
            sort_by: this.currentSort.by,
            status: this.activeTab,
        };
        if (this.activeTab !== 'ignored' && this.activeTab !== 'fixed') {
            if (this.activeTab !== 'all') {
                getPageParams.priority = this.activeTab;
            }
            getPageParams.status = 'active';
        } else {
            getPageParams.status = this.activeTab;
        }
        this.quickHelpLoading = true;
        this.progress = this.dataPrivacyRulesetRepo.getAllForPage(this.pageObj.id, getPageParams).then((infoTypes: any) => {
            this.infoTypes = infoTypes;
            this.complianceData = [
                this.pageObj.data_protection_violations_counts.violations_count -
                    this.pageObj.data_protection_violations_counts.active_violations,
                this.pageObj.data_protection_violations_counts.active_violations,
            ];

            if (this.infoTypes.length > 0) {
                this.setSelectedInfoType(this.infoTypes[0]);
            }
        }, () => {});
    };

    setSelectedInfoType (violation: any): void {
        this.selectedInfoType = violation;
        if (violation) {
            this.quickHelpLoading = true;
            this.description = '';
            const helpCenterParams = {
                identifier: violation.identifier,
            };
            const violationParams: any = {
                info_type: violation.id,
                status: this.activeTab,
            };
            if (this.activeTab === 'ignored' || this.activeTab === 'fixed') {
                violationParams.status = this.activeTab;
            } else {
                violationParams.status = 'active';
            }
            const promises = [
                this.helpCenterRepoService.get(helpCenterParams),
                this.dataPrivacyViolationRepoService.getAll(this.pageObj.id, violationParams),
            ];

            Promise.all(promises)
                .then((data: any) => {
                    if (data[0].length > 0) {
                        this.description = data[0][0].description;
                    }
                    this.violations = data[1];
                }, () => {})
                .finally(() => {
                    this.quickHelpLoading = false;
                });
        }
    }

    async update (status: string, violation: any, confirmMessage: string): Promise<void> {
        try {
            await this.monModalService.confirm(confirmMessage);
        } catch (e) {
            return;
        }

        this.setSelectedInfoType(null);
        const violationToUpdate = safeClone(violation);
        violationToUpdate.status = status;
        this.active = this.selectDataPrivacySection();

        try {
            this.progress = this.dataPrivacyViolationRepoService.updatePageViolation(this.pageObj.id, violationToUpdate);
            await this.progress;
        } catch (e) {
            return;
        }

        this.getPage();
        this.refreshPage.emit({ target: 'page-details-section-data-privacy' });
    }

    openIssueModal (violation: any): void {
        this.directNavigationService.navigateToIssueOverlay({
            issueOverlayIssueId: violation.id,
            issueOverlayContentId: violation.data_protection_content_id,
            issueOverlayIssueType: 'dataPrivacy',
            issueOverlayPageId: this.pageObj.id,
        });
    }

    formatText (text: string): string {
        return this.dataPrivacyService.formatText(text);
    }
}
